var map = {
	"./anna_k.jpg": "d3d5",
	"./gena_s.jpg": "f16f",
	"./girl-qstand.jpg": "4c29",
	"./groupoffice.jpg": "565b",
	"./making-happy.jpg": "4055",
	"./mykola_s.jpg": "bf35",
	"./sandra_s.jpg": "edff",
	"./team.jpg": "37b6",
	"./tom_v.jpg": "966a",
	"./workbench.jpg": "d5c3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4d59";